/**
 * Fragments the settings audit's own groups are anchored on.
 *
 * Its own module so a surface that links INTO the audit does not pull
 * the whole audit view into its bundle for one string, and so the
 * render and the link read the same function rather than two spellings
 * of one convention.
 *
 * Round 11 C5: the app-settings groups have carried an anchor since
 * round 10 and the environment groups did not, so a surface naming a
 * figure that lives in the environment had nowhere to send a reader.
 */

/** The fragment for an environment-variable group heading. */
export function envAnchor(group: string): string {
  return group
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-");
}
